export default "__VITE_ASSET__dedaa017__"